<template>
  <Card :title="$t('global.bandwidth')">
    <div class="row">
      <div class="col-sm-6">
        <img
          class="img-responsive img-thumbnail image-preview"
          width="652"
          height="359"
          :src="`/service/${server.id}.graph?span=day`"
          :alt="$t('global.day')"
        />
        <p class="text-center">
          <b>{{ $t("global.day") }}</b>
        </p>
        <img
          class="img-responsive img-thumbnail image-preview"
          width="652"
          height="359"
          :src="`/service/${server.id}.graph?span=month`"
          :alt="$t('global.month')"
        />
        <p class="text-center">
          <b>{{ $t("global.month") }}</b>
        </p>
      </div>
      <div class="col-sm-6">
        <img
          class="img-responsive img-thumbnail image-preview"
          width="652"
          height="359"
          :src="`/service/${server.id}.graph?span=week`"
          :alt="$t('global.week')"
        />
        <p class="text-center">
          <b>{{ $t("global.week") }}</b>
        </p>
        <img
          class="img-responsive img-thumbnail image-preview"
          width="652"
          height="359"
          :src="`/service/${server.id}.graph?span=year`"
          :alt="$t('global.year')"
        />
        <p class="text-center">
          <b>{{ $t("global.year") }}</b>
        </p>
      </div>
    </div>
  </Card>
</template>

<script>
import Card from "@/components/display/Card";

export default {
  name: "ServerGraphsCard",
  components: {
    Card,
  },
  props: {
    server: {
      type: Object,
      required: true,
    },
  },
};
</script>
